import createKefu from '../utils/createKefu';
import app from '../app';

const qiyuId = process.env.REACT_APP_QIYU_ID;
const origin = process.env.REACT_APP_ORIGIN;

export default function initKefu() {
  if (qiyuId && window.location.origin === origin && !app.weapp) {
    importQiyuSDK();
  }

  return {
    kefu: createKefu(function() {
      if (window.ysf) {
        window.ysf.apply(window, arguments);
      }
    }),
  };
}

function importQiyuSDK() {
  (function(w, d, n, j) {
    w[n] =
      w[n] ||
      function() {
        return (w[n].a = w[n].a || []).push(arguments);
      };
    j = d.createElement('script');
    j.async = true;
    j.src = `https://qiyukf.com/script/${qiyuId}.js?hidden=1`;
    d.body.appendChild(j);
  })(window, document, 'ysf');
}
